module.exports = __webpack_public_path__ + "static/media/white-tick.69925078.svg";